/**
 * Kategorijas / Zīmoli switch + desktop arrows + phone scroll indicator (snippets/emk-collection-circles.liquid).
 */
(function () {
  // Shows the desktop arrows only when the row is wider than its column, and disables the arrow at each end
  function updateArrows(panel) {
    var track = panel.querySelector("[data-emk-track]");
    if (!track) return;
    var prev = panel.querySelector('[data-emk-arrow="-1"]');
    var next = panel.querySelector('[data-emk-arrow="1"]');
    if (track.scrollWidth <= track.clientWidth + 1) {
      panel.removeAttribute("data-overflow");
      return;
    }
    panel.setAttribute("data-overflow", "");
    // Scroll indicator (phone): thumb as wide as the visible part of the row, moving with the scroll
    var thumb = panel.querySelector("[data-emk-bar]");
    if (thumb) {
      var visible = track.clientWidth / track.scrollWidth;
      var max = track.scrollWidth - track.clientWidth;
      thumb.style.width = (visible * 100) + "%";
      thumb.style.transform = "translateX(" + ((max > 0 ? track.scrollLeft / max : 0) * (1 / visible - 1) * 100) + "%)";
    }
    if (prev) prev.disabled = track.scrollLeft <= 1;
    if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;
  }

  function init(root) {
    if (root.hasAttribute("data-emk-ready")) return;
    root.setAttribute("data-emk-ready", "");

    var panels = root.querySelectorAll(".emk-circles__panel");
    panels.forEach(function (panel) {
      var track = panel.querySelector("[data-emk-track]");
      if (track) track.addEventListener("scroll", function () { updateArrows(panel); }, { passive: true });
      updateArrows(panel);
    });

    root.querySelectorAll("[data-emk-arrow]").forEach(function (arrow) {
      arrow.addEventListener("click", function () {
        var track = arrow.closest(".emk-circles__panel").querySelector("[data-emk-track]");
        track.scrollBy({ left: Number(arrow.getAttribute("data-emk-arrow")) * track.clientWidth * 0.8, behavior: "smooth" });
      });
    });

    root.querySelectorAll("[data-emk-tab]").forEach(function (tab) {
      tab.addEventListener("click", function () {
        root.querySelectorAll("[data-emk-tab]").forEach(function (t) {
          var active = t === tab;
          t.setAttribute("aria-selected", active ? "true" : "false");
          var panel = document.getElementById(t.getAttribute("aria-controls"));
          if (panel) {
            panel.hidden = !active;
            if (active) updateArrows(panel);
          }
        });
      });
    });

    window.addEventListener("resize", function () { panels.forEach(updateArrows); });
  }

  function initAll() {
    document.querySelectorAll("[data-emk-circles]").forEach(init);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", initAll);
  else initAll();
  document.addEventListener("shopify:section:load", initAll);
})();

/**
 * Video cards: the play button starts the video inline with controls (sections/emk-video-cards.liquid).
 */
(function () {
  document.addEventListener("click", function (event) {
    var button = event.target.closest && event.target.closest("[data-emk-play]");
    if (!button) return;
    var media = button.closest("[data-emk-video]");
    var video = media && media.querySelector("video");
    if (!video) return;
    media.classList.add("is-playing");
    video.controls = true;
    var playing = video.play();
    if (playing && playing.catch) playing.catch(function () {});
  });
})();
